export class DoublyLinkedListNode<ValueT> {
  constructor(
    public value: ValueT,
    public next: DoublyLinkedListNode<ValueT> | null = null,
    public prev: DoublyLinkedListNode<ValueT> | null = null
  ) { }
}

export class DoublyLinkedList<ValueT> {
  head: DoublyLinkedListNode<ValueT> | null = null;
  tail: DoublyLinkedListNode<ValueT> | null = null;
  size = 0;

  add(value: ValueT) {
    const node = new DoublyLinkedListNode(value);
    if (!this.head) {
      this.head = node;
      this.tail = node;
    } else {
      this.tail!.next = node;
      node.prev = this.tail;
      this.tail = node;
    }
    this.size++;
  }

  remove(node: DoublyLinkedListNode<ValueT>) {
    if (!node.prev) {
      this.head = node.next;
    } else {
      node.prev.next = node.next;
    }

    if (!node.next) {
      this.tail = node.prev;
    } else {
      node.next.prev = node.prev;
    }
    this.size--;
  }

  *[Symbol.iterator]() {
    let current = this.head;
    while (current) {
      yield current;
      current = current.next;
    }
  }
}